import { LayerModule } from "./.LayerModule";
import { OverlayLayerModule } from "./OverlayLayerModule";
import { Layer3DTilesModule } from "./Layer3DTilesModule";
import { ModelLayerModule } from "./ModelLayerModule";
import { ModelsetLayerModule } from "./ModelsetLayerModule";
import { PhotogrammetryModelLayerModule } from "./PhotogrammetryModelLayerModule";
import { PipelineLayerModule } from "./PipelineLayerModule";
import { CustomEconomicDataLayerModule } from "./CustomEconomicDataLayerModule";
import { VectorTileLayerModule } from "./VectorTileLayerModule";
import { LayerI3SModule } from "./LayerI3SModule";
import { LayerGroupModule } from "./LayerGroupModule";

export class LayerModuleFactory {
    static CreateLayer = (terrainView, layerInfo) => {
        let rtn;
        let type = layerInfo.Class.toLowerCase();
        switch (type) {
            case "folder": {
                rtn = new LayerGroupModule(terrainView, layerInfo);
                break;
            }
            case "overlay": {
                rtn = new OverlayLayerModule(terrainView, layerInfo);
                break;
            }
            case "modelset": {
                rtn = new ModelsetLayerModule(terrainView, layerInfo);
                break;
            }
            case "pipeline": {
                rtn = new PipelineLayerModule(terrainView, layerInfo);
                break;
            }
            case "vectortile": {
                rtn = new VectorTileLayerModule(terrainView, layerInfo);
                break;
            }
            // case "vector3d": {
            //     rtn = new VectorLayerController(terrainView, layerInfo);
            //     break;
            // }
            case "bim": {
                rtn = new ModelLayerModule(terrainView, layerInfo);
                break;
            }
            case "photogrammetry": {
                rtn = new PhotogrammetryModelLayerModule(terrainView, layerInfo);
                break;
            }
            case "customeconomic": {
                rtn = new CustomEconomicDataLayerModule(terrainView, layerInfo);
                break;
            }
            // case "well": {
            //     rtn = new WellLayerController(terrainView, layerInfo);
            //     break;
            // }
            // case "landmark3d": {
            //     rtn = new LandMark3DLayerController(terrainView, layerInfo);
            //     break;
            // }
            // case "multi": {
            //     rtn = new MultiLayerController(terrainView, layerInfo);
            //     break;
            // }
            case "3dtiles": {
                rtn = new Layer3DTilesModule(terrainView, layerInfo);
                break;
            }
            case "i3s": {
                rtn = new LayerI3SModule(terrainView, layerInfo);
                break;
            }
            case "clicklayer":
            default:
                rtn = new LayerModule(terrainView, layerInfo)
                break;
        }
        return rtn;
    }
}